export function formatFloat (value) {
  return value.toLocaleString('de-DE', {'minimumFractionDigits': 2})
}
